import { Box, Flex, HStack, List, ListIcon, ListItem, Stack } from '@chakra-ui/react';
import BedrockLayout from '@components/layout/layout/DefaultLayout/bedrock/BedrockLayout';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import SignUpForm from '../components/bedrock/SignUpForm';

const GetStarted = () => {
  const router = useRouter();

  useEffect(() => {
    const isBedrockHost = window.location.host.startsWith('app.');
    if (!isBedrockHost) router.push(Routes.index);
  }, [router]);

  const listContent = [
    'Grow your business, close faster, retain longer, and do it compliantly.',
    'Track clients, quote, and enroll in one app.',
    'Lightning fast SOAs.',
    'Algorithmic plan recommendations.',
  ];

  return (
    <BedrockLayout>
      <Flex minH={{ base: '100vh', md: '100vh' }} bg="white">
        <Flex mx="auto" bg="white" width="full" display={{ base: 'flex', lg: 'flex' }} mb={50} maxW="1400px">
          <Box flex="1" display={{ base: 'none', md: 'block' }}>
            <Flex direction="column" px={{ base: '4', md: '8' }}>
              <Flex align="center" mt={100} />
              <Flex flex="1" align="center">
                <Stack spacing="8">
                  <Stack spacing="6">
                    <Header as="h1" textColor="primary.500" size={{ md: 'lg', xl: 'xl' }}>
                      Join Bedrock
                    </Header>
                    <Header as="h3" maxW="md" fontWeight="medium" color="fg.accent.muted">
                      Software superpowers for Medicare agents.
                    </Header>
                  </Stack>
                  <List spacing={3}>
                    {listContent.map((content) => (
                      // eslint-disable-next-line react/jsx-key
                      <ListItem>
                        <HStack>
                          <ListIcon as={FontAwesomeIcon} icon={faCheckCircle} color="green" h="1.5rem" w="1.5rem" />
                          <Body1>{content}</Body1>
                        </HStack>
                      </ListItem>
                    ))}
                  </List>
                  <HStack spacing="4">
                    <Header as="h3" color="primary.500" fontWeight="medium">
                      15,000+ seniors enrolled.
                    </Header>
                  </HStack>
                </Stack>
              </Flex>
            </Flex>
          </Box>
          <Flex flex="1">
            <SignUpForm
              px={{ base: '4', md: '8' }}
              maxW={{ base: '100%', md: '95%', lg: '90%' }}
              mt={100}
              width="full"
              h="fit-content"
              border="1px"
              borderColor="gray.200"
            />
          </Flex>
        </Flex>
      </Flex>
    </BedrockLayout>
  );
};

export default GetStarted;
